var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("progress-bar", {
        attrs: { type: "info", striped: "", label: "" },
        model: {
          value: _vm.percentageCompleted,
          callback: function ($$v) {
            _vm.percentageCompleted = $$v
          },
          expression: "percentageCompleted",
        },
      }),
      _vm._v(" "),
      _c("aristotle-file-pond", {
        ref: "aristotlepond",
        attrs: {
          url: _vm.url,
          "status-url": _vm.statusUrl,
          "label-idle": _vm.labelIdle,
          "accepted-file-types": _vm.acceptedFileTypes,
          "file-validate-type-label-expected-types-map":
            _vm.fileValidateTypeLabelExpectedTypesMap,
          fileValidateTypeDetectType: _vm.getCustomMIMEType,
          server: {
            process: (fieldName, file, metadata, load, error) =>
              _vm.postFile(file, load, error, true),
            revert: null,
            fetch: null,
          },
          "current-tags": _vm.currentTags,
          "selected-work-group": _vm.selectedWorkGroup,
          "content-type": _vm.contentType,
          "item-id": _vm.itemId,
          disabled: false,
        },
        on: {
          processfileprogress: (file, progress) => _vm.changeProgress(progress),
          removefile: _vm.setInitialState,
          changeProgress: _vm.changeProgress,
          changeLoadingMessage: _vm.changeLoadingMessage,
          changeNumberOfSteps: _vm.changeNumberOfSteps,
          changeFileIsLoaded: _vm.changeFileIsLoaded,
          changeErrors: _vm.changeErrors,
          changeListOfMetadataRepresentations:
            _vm.changeListOfMetadataRepresentations,
          changeIsLoading: _vm.changeIsLoading,
          changeExcelToCsvMessage: _vm.changeExcelToCsvMessage,
          changeShowLoginMessage: _vm.changeShowLoginMessage,
          changeTags: _vm.changeTags,
          changeSelectedWorkgroup: _vm.changeSelectedWorkgroup,
        },
      }),
      _vm._v(" "),
      _c("file-uploader-error-display", { attrs: { errors: _vm.errors } }),
      _vm._v(" "),
      _vm.showLoginMessage
        ? _c("div", { staticClass: "alert alert-info" }, [
            _vm._v(
              "\n            Your file has been processed and the following metadata items were found in the file.\n            You will need to log in to save these metadata items.\n        "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.excelToCsvMessage
        ? _c("div", { staticClass: "alert alert-info" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.excelToCsvMessage) + "\n        "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.percentageCompleted === 0
        ? _c("sddf-templates", {
            attrs: {
              "excel-template-file-path": _vm.excelTemplateFilePath,
              "excel-example-file-path": _vm.excelExampleFilePath,
              "csv-template-file-path": _vm.csvTemplateFilePath,
              "csv-example-file-path": _vm.csvExampleFilePath,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "div",
            { staticClass: "col-sm-4" },
            [
              _vm.fileIsLoaded
                ? _c("file-uploader-options", {
                    attrs: {
                      "user-workgroups": _vm.userWorkgroups,
                      "user-tags": _vm.userTags,
                      "selected-work-group": _vm.selectedWorkGroup,
                      type: "sddf",
                    },
                    on: {
                      changeSelectedWorkgroup: _vm.changeSelectedWorkgroup,
                      changeTags: _vm.changeTags,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("table-of-contents", {
                attrs: {
                  "list-of-metadata-representations": _vm.cleanList(
                    _vm.reversedListOfMetadataRepresentations
                  ),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-8" },
            [
              _vm.fileIsLoaded
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-success pull-right",
                      on: { click: _vm.submitFile },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.buttonMessage) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.fileIsLoaded
                ? _c("p", [
                    _vm._v(
                      '\n                    Your data dictionary file has been processed and the following metadata items were found in the\n                    file. Click "' +
                        _vm._s(_vm.buttonMessage) +
                        '" to save these items into the registry.\n                '
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.percentageCompleted === 100
                ? _c("p", [
                    _vm._v(
                      "\n                    The objects provided in the file have been successfully created! Click on the links below to see\n                    the items in a new tab.\n                "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("metadata-representation", {
                attrs: {
                  "list-of-metadata-representations": _vm.cleanList(
                    _vm.reversedListOfMetadataRepresentations
                  ),
                },
              }),
              _vm._v(" "),
              _vm.fileIsLoaded
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-success pull-right",
                      on: { click: _vm.submitFile },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.buttonMessage) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isLoading
            ? _c("loading", {
                attrs: { "loading-message": _vm.loadingMessage },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }